"use client";

import "@/components/home/final-cta.css";
import "@/components/ui/atoms/categories/layout.css";
import { useSession } from "@/lib/auth/client";
import { routes } from "@/lib/routing/routes";
import { heroSerif } from "@/lib/theme/hero-serif";

import { ArrowRight } from "lucide-react";
import Image from "next/image";
import { Button } from "@/components/ui/shadcn/button";
import Link from "next/link";

import { memo } from "react";

export const FinalCtaSection = memo(function FinalCtaSection() {
    const { data: session } = useSession();
    const isAuthenticated = !!session?.user;

    return (
        <section className={`dw-home-final-cta ${heroSerif.variable}`} aria-label="Start your free trial" data-component="FinalCtaSection" data-location="src/components/home/final-cta.tsx">
            <div className="dw-home-final-cta__card dw-marketing-card">
                <Image src="/graphics/dw-jet-cta2.webp" alt="A jet cutting through haze, its afterburner igniting a prismatic trail across a deep blue sky" fill sizes="100vw" className="dw-home-final-cta__image" />
                <div className="dw-home-final-cta__scrim" aria-hidden />
                <div className="dw-home-final-cta__copy">
                    <h2 className="dw-text-marketing-display">Go supersonic.</h2>
                    <p className="dw-home-final-cta__subline dw-text-body">Bring your clients over in one click. Fluid preps your first round today.</p>
                    <Button asChild size="lg">
                        <Link href={isAuthenticated ? routes.crm.dashboard : routes.crm.signup}>
                            <ArrowRight aria-hidden />
                            {isAuthenticated ? "Go to Dashboard" : "Start Free Trial"}
                        </Link>
                    </Button>
                </div>
            </div>
        </section>
    );
});
